<template>
    <v-card class="main-content-card" flat>
        <v-toolbar flat>
            <v-toolbar-title>内容发布</v-toolbar-title>
            <span class="subheading ml-2">|</span>
            <v-btn round small color="primary" class="ml-3"
                   :disabled="!funcIds.includes('c_web_article')"
                   @click.native.stop="() => { editDbid = null; editArticle = true; }">
              <v-icon dark small>edit</v-icon>新建内容
            </v-btn>

            <v-btn round small color="teal" dark
                   :disabled="!funcIds.includes('c_web_article')"
                   @click.native.stop="() => { editDbid = null; editReport = true; }">
              <v-icon dark small>group</v-icon>新建学术活动
            </v-btn>

        </v-toolbar>

        <!-- 检索功能区 -->
        <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
            <v-layout row wrap>
                <v-flex d-flex xs10>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="标题"
                                    v-model="form.title"
                                    :clearable="true"
                                    hide-details
                            />
                        </v-flex>

                        <v-flex xs12 sm4>
                            <v-select
                                    item-text="name"
                                    item-value="dbid"
                                    :items="sectionItems"
                                    v-model="form.sectionId"
                                    label="栏目"
                                    hide-details
                                    clearable
                            />
                        </v-flex>

                        <v-flex xs12>
                            <span>发布状态：</span>
                            <v-btn-toggle
                                    v-model="form.draft"
                                    class="transparent"
                                    style="background:none;box-shadow:none"
                            >
                                <v-btn value="" flat>全部</v-btn>
                                <v-btn flat value="T"><span>草稿</span></v-btn>
                                <v-btn flat value="F"><span>发布</span></v-btn>
                            </v-btn-toggle>
                        </v-flex>

                    </v-layout>
                </v-flex>
                <v-flex d-flex xs2 text-xs-center>
                    <div>
                        <v-btn color="primary" @click="onSearch">
                            <v-icon dark>search</v-icon>
                            检索
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>

        <v-divider/>
        <v-data-table
                :headers="headers"
                :loading="loading"
                item-key="dbid"
                :pagination.sync="query"
                :items="pageResult.items"
                :total-items="pageResult.total"
                :rows-per-page-items="[10, 25, 50, 100, 200]"
        >
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.index + 1}}
                </td>
                <td>{{ props.item.title }}</td>
                <td>{{ props.item.pubDate }}</td>
                <td>{{ props.item.section.name }}</td>
                <td>{{ props.item.author }}</td>
                <td>{{ props.item.draft === true ? "是" : "否" }}</td>

                <td class="justify-center layout px-0">
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               target="_blank"
                               :href="`/#/${props.item.section.identifier}/${props.item.dbid}`">
                            <v-icon color="teal">more_horiz</v-icon>
                        </v-btn>
                        <span>预览</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               :disabled="!(
                                       funcIds.includes('u_web_article')
                                       || (userId === props.item.authorId && in3Days(props.item.pubDate))
                                     )"
                               @click="() => {
                      editDbid = props.item.dbid;
                      if(props.item.section.identifier === 'report'){
                        editReport = true;
                      } else {
                        editArticle = true;
                      }
                   }">
                            <v-icon color="teal">edit</v-icon>
                        </v-btn>
                        <span>编辑</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               :disabled="!funcIds.includes('d_web_article')"
                               @click="() => { deleDbid = props.item.dbid; deleMsg = props.item.title; dele = true; }">
                            <v-icon color="pink">delete_forever</v-icon>
                        </v-btn>
                        <span>删除</span>
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>

        <x-edit-article
                v-model="editArticle"
                :dbid="editDbid"
                v-on:ok="onEditOk"
        />

        <x-edit-report
                v-model="editReport"
                :dbid="editDbid"
                v-on:ok="onEditOk"
        />

        <x-delete
                v-model="dele"
                :message="deleMsg"
                :uri="uri"
                :dbid="deleDbid"
                v-on:ok="onDeleOk"
        />

    </v-card>
</template>

<script>
    import {mapGetters} from 'vuex'

    import XEditArticle from './EditArticle'
    import XEditReport from './EditReport'
    import XDelete from '../../global/Delete'

    import mixin from '@/mixin'

    const baseUri = '/api/web/article';
    const sectionUri = '/api/web/section';

    export default {
        // 混入模块主页面（index）基本功能
        mixins: [mixin.index(baseUri)],

        components: {XEditArticle, XEditReport, XDelete},

        data() {
            return {
                uri: baseUri,

                // 检索、分页、排序条件条件
                query: {
                    title: '',
                    sectionId: '',
                    draft: '',

                    page: 1,
                    rowsPerPage: 25,
                    sortBy: null,
                    descending: null,
                    totalItems: null
                },

                // 检索框
                form: {
                    title: '',
                    sectionId: '',
                    draft: '',
                },

                // 表头
                headers: [
                    {text: '#', align: 'left', sortable: false, value: 'dbid', width: 20},
                    {text: '标题', align: 'left', sortable: true, value: 'title'},
                    {text: '发布时间', align: 'left', sortable: true, value: 'pubDate', width: 120},
                    {text: '栏目', align: 'left', sortable: true, value: 'section', width: 150},
                    {text: '作者', align: 'left', sortable: true, value: 'author', width: 120},
                    {text: '草稿', align: 'left', sortable: true, value: 'draft'},
                    {text: '操作', align: 'center', sortable: false, value: 'dbid', width: 100}
                ],

                sectionItems: [],

                rowIdx: null,

                editArticle: false,
                editReport: false,
                editDbid: null,

                dele: false,
                deleDbid: null,
                deleMsg: null,
            }
        },

        computed: {
            ...mapGetters(['funcIds', "userId"])
        },

        created() {
            this.axios.get(sectionUri, {params: {limit: 65535, sort: 'rank.asc'}})
                .then(
                    rsp => {
                        this.sectionItems = rsp.data.items;
                    })
        },

        methods: {
            in3Days(date) {
                const d = new Date();
                d.setDate(d.getDate() - 3);
                return new Date(date) > d;
            },
            // 检索响应函数
            onSearch() {
                Object.assign(this.query, this.form);
                this.query.page = 1;
                this.doRoute(this.query);
            },
        }
    }
</script>
